import {css} from "@emotion/react";

import {
    ARROW_7_MOBILE_HEIGHT_PX,
    ARROW_7_NATURAL_W_PX,
    ARROW_CARD_PADDING_INSET_PX,
    ARROW_MONITORING_H,
    ARROW_MONITORING_W,
    ARROW_NUDGE_PX,
    ARROW_PREZENTACJE_H,
    ARROW_PREZENTACJE_W,
    ARROW_RESEARCH_H,
    ARROW_RESEARCH_W,
    DIAGRAM_DESKTOP_MIN_PX,
    DIAGRAM_MOBILE_ARROW_ASSET_SCALE,
    DIAGRAM_MOBILE_MAX_PX
} from "./bigDataHowItWorksDiagramConstants";

export const arrowMobileImg = css`
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

/** Treść tylko na desktopie diagramu (np. SVG inline). */
export const hideOnMobile = css`
    @media (max-width: ${DIAGRAM_MOBILE_MAX_PX}px) {
        display: none;
    }
`;

/** Treść tylko na mobile diagramu (np. img z /public). */
export const hideOnDesktop = css`
    @media (min-width: ${DIAGRAM_DESKTOP_MIN_PX}px) {
        display: none;
    }
`;

const DIAGRAM_ARROW_STROKE = "#D3D3D5";
const DIAGRAM_ARROW_STROKE_W = 2;

export const pathResearchArrow =
    "M61.4962 0.129195C58.6214 -0.51239 55.7708 1.29798 55.1292 4.17278C54.4876 7.04758 56.298 9.89816 59.1728 10.5398C62.0476 11.1813 64.8982 9.37096 65.5398 6.49617C66.1813 3.62137 64.371 0.77078 61.4962 0.129195ZM21.3278 5.33447L21.3278 4.33447L21.3278 4.33447L21.3278 5.33447ZM5.40906 21.3321L4.40907 21.3371V21.3371L5.40906 21.3321ZM6.49616 108.129C3.62137 107.488 0.770778 109.298 0.129192 112.173C-0.512393 115.048 1.29798 117.898 4.17278 118.54C7.04757 119.181 9.89816 117.371 10.5397 114.496C11.1813 111.621 9.37096 108.771 6.49616 108.129ZM60.3345 5.33447L60.3345 4.33447L21.3278 4.33447L21.3278 5.33447L21.3278 6.33447L60.3345 6.33447L60.3345 5.33447ZM5.40906 21.3321L4.40907 21.3371C4.48567 36.4852 4.59746 59.4899 4.62487 78.7043C4.63858 88.312 4.63119 96.9694 4.5878 103.222C4.5661 106.35 4.53543 108.871 4.49404 110.607C4.4733 111.477 4.45009 112.14 4.42464 112.58C4.41169 112.804 4.39922 112.951 4.38886 113.034C4.38283 113.081 4.38172 113.072 4.39135 113.036C4.3939 113.026 4.41419 112.945 4.46807 112.846C4.49436 112.798 4.55786 112.69 4.67643 112.584C4.80396 112.471 5.04556 112.321 5.3789 112.335L5.33447 113.334L5.29003 114.333C5.62745 114.348 5.8731 114.196 6.00466 114.08C6.12726 113.971 6.19476 113.857 6.22503 113.802C6.28686 113.688 6.315 113.585 6.32531 113.546C6.35046 113.45 6.36447 113.353 6.37318 113.284C6.3923 113.132 6.40778 112.93 6.42131 112.696C6.44879 112.22 6.47261 111.529 6.49347 110.654C6.53527 108.901 6.56604 106.366 6.58776 103.236C6.63121 96.9746 6.63858 88.3103 6.62487 78.7015C6.59745 59.4829 6.48565 36.4748 6.40905 21.327L5.40906 21.3321ZM21.3278 5.33447L21.3278 4.33447C11.9371 4.33447 4.36159 11.9463 4.40907 21.3371L5.40906 21.3321L6.40905 21.327C6.36717 13.045 13.0453 6.33447 21.3278 6.33447L21.3278 5.33447Z";

export const pathPresentationsArrow =
    "M0.182868 3.95435C-0.579488 6.7995 1.10895 9.72396 3.9541 10.4863C6.79926 11.2487 9.72372 9.56024 10.4861 6.71509C11.2484 3.86993 9.55999 0.945469 6.71484 0.183112C3.86969 -0.579244 0.945225 1.1092 0.182868 3.95435ZM5.46766 42.7901L6.46766 42.7914V42.7914L5.46766 42.7901ZM21.2982 58.8297L21.2951 57.8297V57.8297L21.2982 58.8297ZM107.183 57.4058C106.421 60.2509 108.109 63.1754 110.954 63.9378C113.799 64.7001 116.724 63.0117 117.486 60.1665C118.248 57.3214 116.56 54.3969 113.715 53.6345C110.87 52.8722 107.945 54.5606 107.183 57.4058ZM5.33447 5.33472C4.3345 5.34196 4.3345 5.34203 4.3345 5.34219C4.3345 5.34236 4.3345 5.3426 4.33451 5.34292C4.33451 5.34357 4.33452 5.34454 4.33453 5.34584C4.33455 5.34843 4.33457 5.35231 4.33461 5.35747C4.33468 5.3678 4.3348 5.38325 4.33494 5.40372C4.33523 5.44466 4.33567 5.50567 4.33623 5.58595C4.33736 5.7465 4.33901 5.98411 4.34111 6.29223C4.3453 6.90847 4.35127 7.8068 4.35835 8.935C4.37253 11.1914 4.39121 14.3673 4.40922 18.0449C4.44522 25.4006 4.47851 34.762 4.46766 42.7887L5.46766 42.7901L6.46766 42.7914C6.47851 34.7584 6.4452 25.3922 6.40919 18.0351C6.39118 14.3564 6.3725 11.1796 6.35832 8.92243C6.35122 7.79386 6.34526 6.89518 6.34106 6.27862C6.33897 5.97034 6.33731 5.73259 6.33618 5.57189C6.33562 5.49154 6.33518 5.43045 6.33489 5.38945C6.33474 5.36894 6.33463 5.35346 6.33456 5.3431C6.33452 5.33792 6.33449 5.33402 6.33447 5.33141C6.33447 5.3301 6.33446 5.32912 6.33445 5.32847C6.33445 5.32814 6.33445 5.32789 6.33445 5.32773C6.33445 5.32756 6.33445 5.32748 5.33447 5.33472ZM21.2982 58.8297L21.3012 59.8296C36.3348 59.784 59.1274 59.6431 78.1183 59.5788C87.6201 59.5466 96.1773 59.5335 102.355 59.5609C105.445 59.5746 107.935 59.5984 109.648 59.6349C110.507 59.6531 111.161 59.6744 111.595 59.6985C111.815 59.7107 111.959 59.7227 112.039 59.7326C112.086 59.7385 112.074 59.7393 112.035 59.729C112.025 59.7262 111.94 59.7048 111.837 59.6473C111.786 59.6191 111.674 59.551 111.567 59.4236C111.449 59.2833 111.309 59.0317 111.338 58.6996L112.334 58.7862L113.331 58.8727C113.36 58.5366 113.219 58.2809 113.098 58.1366C112.987 58.0053 112.869 57.9331 112.812 57.901C112.695 57.8356 112.588 57.8064 112.549 57.7961C112.453 57.7704 112.355 57.7565 112.286 57.748C112.136 57.7292 111.936 57.7144 111.705 57.7015C111.236 57.6755 110.555 57.6537 109.691 57.6353C107.96 57.5985 105.456 57.5746 102.364 57.5609C96.1778 57.5335 87.6139 57.5466 78.1116 57.5788C59.0942 57.6432 36.346 57.784 21.2951 57.8297L21.2982 58.8297ZM5.46766 42.7901L4.46766 42.7887C4.45499 52.1598 11.8915 59.8582 21.3012 59.8296L21.2982 58.8297L21.2951 57.8297C13.0319 57.8547 6.45643 51.0934 6.46766 42.7914L5.46766 42.7901Z";

export const pathMonitoringArrow =
    "M61.4336 117.068C58.5884 117.831 55.664 116.142 54.9016 113.297C54.1393 110.452 55.8277 107.528 58.6729 106.765C61.518 106.003 64.4425 107.691 65.2048 110.536C65.9672 113.382 64.2787 116.306 61.4336 117.068ZM21.3272 111.758L21.3281 112.758V112.758L21.3272 111.758ZM5.29136 95.9219L4.29136 95.9188L5.29136 95.9219ZM6.71507 10.4864C3.86991 11.2487 0.94545 9.56028 0.183093 6.71513C-0.579263 3.86997 1.10918 0.945507 3.95433 0.18315C6.79948 -0.579206 9.72395 1.10924 10.4863 3.95439C11.2487 6.79954 9.56022 9.72401 6.71507 10.4864ZM60.0532 111.917C60.0455 112.917 60.0454 112.917 60.0452 112.917C60.045 112.917 60.0448 112.917 60.0445 112.917C60.0438 112.917 60.0428 112.917 60.0414 112.917C60.0387 112.917 60.0347 112.917 60.0293 112.917C60.0186 112.917 60.0025 112.916 59.9812 112.916C59.9386 112.916 59.8751 112.916 59.7916 112.915C59.6246 112.914 59.3775 112.912 59.0572 112.909C58.4164 112.905 57.4827 112.898 56.3107 112.89C53.9668 112.874 50.67 112.853 46.8588 112.832C39.236 112.791 29.557 112.751 21.3281 112.758L21.3272 111.758L21.3264 110.758C29.5616 110.751 39.2455 110.791 46.8697 110.832C50.682 110.853 53.9797 110.874 56.3244 110.89C57.4967 110.898 58.4308 110.905 59.0718 110.909C59.3923 110.912 59.6396 110.914 59.8067 110.915C59.8903 110.916 59.9539 110.916 59.9965 110.916C60.0178 110.917 60.034 110.917 60.0447 110.917C60.0501 110.917 60.0542 110.917 60.0569 110.917C60.0583 110.917 60.0593 110.917 60.06 110.917C60.0603 110.917 60.0606 110.917 60.0607 110.917C60.0609 110.917 60.061 110.917 60.0532 111.917ZM5.29136 95.9219L4.29136 95.9188C4.33721 80.9366 4.47795 58.2555 4.54218 39.3645C4.57432 29.9125 4.58735 21.4019 4.55993 15.2581C4.54621 12.1853 4.52238 9.70966 4.48593 8.00586C4.46766 7.15202 4.44641 6.50221 4.42235 6.07097C4.41011 5.85152 4.39818 5.7088 4.38829 5.62996C4.38246 5.58347 4.38167 5.59541 4.3922 5.63485C4.395 5.64534 4.4167 5.73098 4.4747 5.83429C4.50312 5.88492 4.57166 5.99748 4.69938 6.10424C4.84016 6.22193 5.09103 6.35969 5.42125 6.331L5.3347 5.33476L5.24814 4.33851C5.58242 4.30947 5.83732 4.44874 5.9821 4.56976C6.11381 4.67987 6.18632 4.79761 6.21868 4.85525C6.28455 4.97259 6.314 5.07957 6.32444 5.11865C6.35025 5.21525 6.36425 5.31329 6.37276 5.38115C6.39154 5.53101 6.40644 5.72994 6.41925 5.95955C6.4453 6.42641 6.4671 7.10427 6.48547 7.96307C6.5223 9.68452 6.54618 12.174 6.5599 15.2492C6.58737 21.4014 6.57431 29.9187 6.54217 39.3713C6.47784 58.2895 6.33725 80.9245 6.29136 95.9249L5.29136 95.9219ZM21.3272 111.758L21.3281 112.758C11.957 112.766 4.26257 105.328 4.29136 95.9188L5.29136 95.9219L6.29136 95.9249C6.26607 104.189 13.0243 110.765 21.3264 110.758L21.3272 111.758Z";

export const DiagramArrowSvg = ({viewBox, pathD}: {viewBox: string; pathD: string}) => (
    <svg
        width="100%"
        height="100%"
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet"
        aria-hidden
        focusable="false"
    >
        <path
            d={pathD}
            fill={DIAGRAM_ARROW_STROKE}
            stroke={DIAGRAM_ARROW_STROKE}
            strokeWidth={DIAGRAM_ARROW_STROKE_W}
            strokeLinejoin="round"
            strokeLinecap="round"
            vectorEffect="nonScalingStroke"
        />
    </svg>
);

export const diagramDesktop = (inner: ReturnType<typeof css>) => css`
    @media (min-width: ${DIAGRAM_DESKTOP_MIN_PX}px) {
        ${inner}
    }
`;

/** Widok < desktop diagramu — strzałki przy kartach (osobne rozmiary niż desktop). */
export const diagramMobile = (inner: ReturnType<typeof css>) => css`
    @media (max-width: ${DIAGRAM_MOBILE_MAX_PX}px) {
        ${inner}
    }
`;

const arrowShared = css`
    z-index: 2;
    pointer-events: none;
    line-height: 0;
    overflow: visible;
    display: block;
    flex-shrink: 0;
`;

/** Research — desktop: w stronę góry laptopa; mobile: Arrow 4 (eksport SVG). */
export const arrowResearchCard = css`
    ${arrowShared}
    position: absolute;

    ${diagramMobile(css`
        left: 15%;
        bottom: -7%;
        transform: none;
    `)}

    ${diagramDesktop(css`
        right: calc(75% - 8px);
        top: calc(70% - ${ARROW_CARD_PADDING_INSET_PX}px);
        bottom: auto;
        width: ${ARROW_RESEARCH_W}px;
        height: ${ARROW_RESEARCH_H}px;
        transform: none;
    `)}
`;

/** Prezentacje — desktop: pod krawędzią karty; mobile: Arrow 8 nad kartą (łuk z laptopa). */
export const arrowPrezentacjeCard = css`
    ${arrowShared}
    position: absolute;

    ${diagramMobile(css`
        top: -22px;
        left: -24px;
        right: auto;
        bottom: auto;
        transform: none;
    `)}

    ${diagramDesktop(css`
        right: -10%;
        top: 98%;
        width: ${ARROW_PREZENTACJE_W}px;
        height: ${ARROW_PREZENTACJE_H}px;
    `)}
`;

/** Monitoring — desktop: pod laptop; mobile: Arrow 7 (pion). */
export const arrowMonitoringCard = css`
    ${arrowShared}
    position: absolute;

    ${diagramMobile(css`
        bottom: 100%;
        left: 16px;
        width: ${ARROW_7_NATURAL_W_PX * DIAGRAM_MOBILE_ARROW_ASSET_SCALE}px;
        height: ${ARROW_7_MOBILE_HEIGHT_PX}px;
        transform: none;
    `)}

    ${diagramDesktop(css`
        left: calc(-7% - ${ARROW_CARD_PADDING_INSET_PX}px);
        top: -12%;
        height: ${ARROW_MONITORING_H}px;
    `)}
`;
